module.exports = __webpack_public_path__ + "static/media/bcn.a0c818de.svg";